/**
 * @file    Callback.jsx
 * @author  Liang Wang <liang@distributive.network>
 * @date    June 2024
 */

import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Redirect to the path specified by the 'state' search param, this is basically used by oauth to
 * get us to what we wanted to go before we were authenticated.
 *
 * @returns {null}
 */
export function Callback({ useDefault }) {
  const navigate = useNavigate();
  const [searchParams, _setSearchParams] = useSearchParams();

  useEffect(() => {
    let redirectPath;

    // Hotpatch 2026-03-13: /worker is no longer a page. Remove soon.
    if (localStorage.getItem('latestPage') === '/worker')
      localStorage.removeItem('latestPage');

    if (useDefault)
    {
      navigate((localStorage.getItem('latestPage') || '/accounts') + window.location.search + window.location.hash, {
        replace: true,
      });
      return;
    }

    try
    {
      redirectPath = new URL(searchParams.get('state'), window.location.origin);
    }
    catch (_e)
    {
      /* silent */
    }

    // avoid the self-loop if the user went to this endpoint directly
    if (redirectPath?.pathname !== '/auth/callback')
      navigate(redirectPath.pathname + redirectPath.search + redirectPath.hash, {
        replace: true,
      });
    else
      navigate('/' + redirectPath.search + redirectPath.hash, {
        replace: true,
      });
  }, [navigate, searchParams]);

  // Sir, we don't serve actual pages here
  return null;
}
